// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableCellColors_ok__MEcAH {\n  background: rgba(0, 128, 0, 0.1);\n}\n.TableCellColors_ko__L72Xi {\n  background: rgba(255, 0, 0, 0.15);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Table/TableCellColors.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC","sourcesContent":[".ok {\n  background: rgba(0, 128, 0, 0.1);\n}\n.ko {\n  background: rgba(255, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ok": "TableCellColors_ok__MEcAH",
	"ko": "TableCellColors_ko__L72Xi"
};
export default ___CSS_LOADER_EXPORT___;
